(function(){
  if(window.__zpfx)return;window.__zpfx=1;
  var d=document;
  function go(){
    if(!d.querySelector('.zp'))return;
    d.documentElement.classList.add('zp-js');
    var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion:reduce)').matches;
    var els=[].slice.call(d.querySelectorAll('.zp-head,.zp-bn,.zp-faq details,.zp-guar,.zp-rc'));
    els.forEach(function(e){
      var i=[].indexOf.call(e.parentNode.children,e);
      e.style.setProperty('--d',(Math.min(i,5)*0.08)+'s');
      e.classList.add('zp-rv');
    });
    function showAll(){els.forEach(function(e){e.classList.add('in');});}
    if(reduce||!('IntersectionObserver' in window)){showAll();}
    else{
      var io=new IntersectionObserver(function(en){en.forEach(function(x){if(x.isIntersecting){x.target.classList.add('in');io.unobserve(x.target);}});},{rootMargin:'0px 0px -40px 0px',threshold:0.05});
      els.forEach(function(e){io.observe(e);});
      setTimeout(showAll,4000);
    }
    var imgs='.zp-bn-art img';
    [].slice.call(d.querySelectorAll(imgs)).forEach(function(img){
      if(img.complete)img.classList.add('ld');
      else{img.addEventListener('load',function(){img.classList.add('ld');});img.addEventListener('error',function(){img.classList.add('ld');});}
    });
    setTimeout(function(){[].slice.call(d.querySelectorAll(imgs)).forEach(function(i){i.classList.add('ld');});},3500);
    var pr=d.querySelector('[data-zp-price]');
    if(pr&&window.MutationObserver){
      new MutationObserver(function(){pr.classList.remove('zp-pop');void pr.offsetWidth;pr.classList.add('zp-pop');}).observe(pr,{childList:true,characterData:true,subtree:true});
    }
    d.addEventListener('cart:refresh',function(e){
      if(!e.detail||e.detail.open!==true)return;
      [].slice.call(d.querySelectorAll('.zp-atc,.zp-bn .zp-btn')).forEach(function(b){
        if(b.classList.contains('is-done')||b.offsetParent===null)return;
        var o=b.textContent;b.classList.add('is-done');b.textContent='Added ✓';
        setTimeout(function(){b.classList.remove('is-done');b.textContent=o;},1800);
      });
    });
  }
  if(d.readyState==='loading')d.addEventListener('DOMContentLoaded',go);else go();
})();